import { render, staticRenderFns } from "./ArticleNewsletter.vue?vue&type=template&id=592d274a&scoped=true"
import script from "./ArticleNewsletter.vue?vue&type=script&lang=ts"
export * from "./ArticleNewsletter.vue?vue&type=script&lang=ts"
import style0 from "./ArticleNewsletter.vue?vue&type=style&index=0&id=592d274a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d274a",
  null
  
)

export default component.exports